import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { makeStyles } from '@material-ui/core/styles'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import React from 'react'

const useStyles = makeStyles(() => ({
    buttonIcon: {
        color: '#dadada',
        backgroundColor: '#5E5F61',
        borderRadius: '50%',
        '&:hover': {
            backgroundColor: '#a78966',
        },
    },
    button: {
        width: 36,
        height: 36,
        zIndex: 3,
    },
    menuItem: {
        color: '#0098D6',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '12px',
    },
}))

interface Item {
    text: string
    onClick: (event: React.MouseEvent) => void
    testId?: string
}
interface ProjectOverviewMenuProps {
    items: Item[]
}
export const ProjectOverviewMenu: React.FC<ProjectOverviewMenuProps> = ({
    items,
}) => {
    const classes = useStyles()
    const [anchorEl, setAnchorEl] = React.useState<null | Element>(null)

    const handleCLose = () => {
        setAnchorEl(null)
    }
    const handleMenuIconClick = (event: React.MouseEvent) => {
        if (anchorEl) {
            handleCLose()
        } else {
            setAnchorEl(event.currentTarget)
        }
    }

    const menu = React.useMemo(() => {
        const handleMenuItemClick = (event: React.MouseEvent, item: Item) => {
            handleCLose()
            if (item.onClick) item.onClick(event)
        }
        if (items.length > 0) {
            return (
                <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    elevation={0}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorEl)}
                    onClose={handleCLose}
                >
                    {items.map((each, index) => (
                        <MenuItem
                            key={`${each.text}${index}`}
                            onClick={(event: React.MouseEvent) =>
                                handleMenuItemClick(event, each)
                            }
                            className={classes.menuItem}
                            data-testid={`${each.testId}-${index}`}
                        >
                            {each.text}
                        </MenuItem>
                    ))}
                </Menu>
            )
        }
        // added classes.menuItem, handleMenuItemClick to remove warning
    }, [items, anchorEl, classes.menuItem])

    return (
        <>
            <IconButton
                data-testid="dvProjectOverviewMenu"
                className={classes.button}
                onClick={handleMenuIconClick}
                aria-label="Project Overview Menu"
            >
                <MoreVertIcon className={classes.buttonIcon} />
            </IconButton>
            {menu}
        </>
    )
}

export default ProjectOverviewMenu
